import { useMutation } from '@apollo/client';
import { useMemo } from 'react';
import useFavoriteTopics, { FAVORITE_TOPIC_QUERY } from './useFavoriteTopics';
import { gql } from '../graphql/generated/gql';
import { legacyUpdateQueryList } from '../utils/graphql/updateQueryList';

const FAVORITE_TOPIC_MUTATION = gql(/** @complexity 2 */ `
  mutation favoriteTopic($id: ID!, $add: Boolean) {
    favoriteTopic(id: $id, add: $add) {
      id
    }
  }
`);

const useToggleFavoriteTopic = (topic: { id: string }) => {
  const favoriteTopics = useFavoriteTopics();

  const isFavorited = useMemo(() => {
    return favoriteTopics.some((ft) => ft.id === topic.id);
  }, [favoriteTopics, topic.id]);

  const [toggleFavoriteTopic] = useMutation(FAVORITE_TOPIC_MUTATION, {
    variables: { id: topic.id, add: !isFavorited },
    optimisticResponse: {
      __typename: 'RootMutationType',
      favoriteTopic: {
        ...topic,
        __typename: 'Topic',
      },
    },
    update: legacyUpdateQueryList(
      { query: FAVORITE_TOPIC_QUERY },
      'currentSession.user.favoriteTopics',
      'favoriteTopic',
      !isFavorited,
    ),
  });

  return { isFavorited, toggleFavoriteTopic };
};

export default useToggleFavoriteTopic;
